import React from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { keyframes } from "@mui/system";

interface StatusCardProps {
    status: "Online" | "Error";
}

const blinkAnimation = keyframes`
  0% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
`;

const StatusCard: React.FC<StatusCardProps> = ({ status }) => {
    // Use green for Online and red for Error
    const indicatorColor = status === "Online" ? "#4caf50" : "#f44336";
    const shouldBlink = status === "Online";

    return (

            <MDBox p={2} display="flex" alignItems="center">
                <MDBox
                    sx={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        backgroundColor: indicatorColor,
                        mr: 1,
                        ...(shouldBlink && {
                            animation: `${blinkAnimation} 2s infinite`,
                        }),
                    }}
                />
                <MDTypography variant="h6">{status}</MDTypography>
            </MDBox>
    );
};

export default StatusCard;
